export default __webpack_public_path__ + "static/psle-slay-screen-5-d4003fea2a78c4cd77c34224d4e38245.png";